/**
 * The one substring-match rule behind every search box in the terminal.
 *
 * Shared rather than copied because two search boxes in one modal that
 * disagree about what "matches" is a bug nobody reports and everybody feels:
 * the Apps & Skills catalog and the Credentials list are searched from the
 * SAME field, so a query that finds `paradex-portfolio-copilot` on one tab
 * and misses `paradex-main` on the next would be the field's fault, not the
 * data's.
 */

/**
 * Loose substring match. Catalog and credential names are dash-separated
 * (`paradex-portfolio-copilot`, `binance-main`) but users type spaces — so we
 * flatten `-` / `_` / `.` in the target to spaces and require every
 * whitespace-delimited query token to appear as a substring. Token order
 * doesn't matter, so "copilot portfolio" still finds the skill above.
 *
 * An empty or whitespace-only query matches everything, which is what makes it
 * safe to call unconditionally instead of branching on "is anything typed".
 */
export function looseIncludes(haystack: string, query: string): boolean {
  const tokens = query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((t) => t.length > 0);
  if (tokens.length === 0) return true;
  const hay = haystack.toLowerCase().replace(/[-_.]+/g, ' ');
  return tokens.every((t) => hay.includes(t));
}
